import React from 'react';
import { Link } from 'react-router-dom';
import timeToShine from '../img/2026/time-to-shine.png';

// Set to false to return the title to the original static artwork.
const ENABLE_TITLE_SPARKLES = true;

const Home = () => {
    return (
        <main className="home-main flex-1 flex items-center justify-center">
            <div className="home-content text-center">
                <h1 className="sr-only">Time to Shine with ALDI Advent Calendar</h1>
                <div className="home-title-wrap">
                    <img className="home-title" src={timeToShine} alt="" aria-hidden="true" />
                    {ENABLE_TITLE_SPARKLES && (
                        <div className="home-title-glints" aria-hidden="true">
                            <span className="home-title-glint home-title-glint-1" />
                            <span className="home-title-glint home-title-glint-2" />
                            <span className="home-title-glint home-title-glint-3" />
                            <span className="home-title-glint home-title-glint-4" />
                            <span className="home-title-glint home-title-star-glint home-title-star-glint-1" />
                            <span className="home-title-glint home-title-star-glint home-title-star-glint-2" />
                            <span className="home-title-glint home-title-star-glint home-title-star-glint-3" />
                            <span className="home-title-glint home-title-star-glint home-title-star-glint-4" />
                            <span className="home-title-glint home-title-star-glint home-title-star-glint-5" />
                            <span className="home-title-glint home-title-star-glint home-title-star-glint-6" />
                            <span className="home-title-glint home-title-star-glint home-title-star-glint-7" />
                            <span className="home-title-glint home-title-star-glint home-title-star-glint-8" />
                            <span className="home-title-glint home-title-star-glint home-title-star-glint-9" />
                        </div>
                    )}
                </div>
                <div className="home-copy">
                    <p>Get ready to unwrap a new game every single day. From brain-teasing brainteasers and jingle-jangling jests to ho-ho-hilarious challenges, there’s a fresh dash of Christmas cheer waiting behind every door. December is about to get seriously merry.</p>
                    <p>Make sure you pop back daily, because this calendar is stuffed with more goodies than your chrissy stocking.</p>
                </div>
                <div className="home-action">
                    <Link to="/calendar" className="btn home-begin-button">
                        <span>Begin</span>
                    </Link>
                </div>
            </div>
        </main>
    );
};

export default Home;
